import { withInstall } from '@zoryn/utils'
import Affix from './src/affix.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZAffix: SFCWithInstall<typeof Affix> = withInstall(Affix)
export default ZAffix

export * from './src/affix'
